let pyodideInstance = null;

export async function runPythonCode(code) {
  if (!pyodideInstance) {
    pyodideInstance = await window.loadPyodide();
  }

  try {
    await pyodideInstance.runPythonAsync(`
import sys
from io import StringIO
sys.stdout = sys.stderr = StringIO()
    `);

    await pyodideInstance.runPythonAsync(code);

    const output = await pyodideInstance.runPythonAsync("sys.stdout.getvalue()");
    return output.trim();
  } catch (err) {
    return `Error: ${err}`;
  }
}
